<template>
  <div>
    <!-- =========================================================
         DESKTOP / TABLET
         ========================================================= -->
    <v-navigation-drawer
      v-if="!isMobile"
      app
      color="primary"
      dark
      class="custom-scrollbar"
      :mini-variant="isMini"
      permanent
    >
      <div class="navigation-layout">
        <!-- =====================================================
             CONTEÚDO / MENU
             Esta zona é que faz scroll.
             ===================================================== -->
        <div class="navigation-scroll custom-scrollbar">
          <NodeList
            :userData="user_data"
            :items="items"
            :isMini="isMini"
          />

          <v-list
            v-if="
              $store.getters.hasPermission([
                'super',
                'tickets.create'
              ])
            "
            nav
            dense
            color="transparent"
          >
            <v-list-item @click="$emit('ticket')">
              <v-list-item-icon>
                <v-icon :small="isMini">
                  mdi-ticket
                </v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                Ticket
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </div>

        <!-- =====================================================
             FOOTER
             Fica sempre preso ao fundo.
             ===================================================== -->
        <div class="navigation-footer">
          <v-divider />

          <v-list
            nav
            dense
            color="transparent"
            class="mb-0"
          >
            <v-list-item
              @click="logout"
              class="logout-item"
            >
              <v-list-item-icon>
                <v-icon :small="isMini">
                  mdi-power
                </v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                Terminar Sessão
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- =========================================================
         MOBILE
         ========================================================= -->
    <v-dialog
      v-else
      v-model="drawerModel"
      fullscreen
      hide-overlay
      scrollable
      content-class="pa-0"
      transition="dialog-bottom-transition"
    >
      <v-card
        class="
          mobile-menu-card
          d-flex
          flex-column
          primary
          white--text
        "
      >
        <!-- =====================================================
             HEADER
             Fica fixo no topo.
             ===================================================== -->
        <v-card-title
          class="
            d-flex
            align-center
            justify-space-between
            px-4
            mobile-menu-header
          "
        >
          <div class="d-flex align-center">
            <v-icon
              class="mr-2"
              color="white"
            >
              mdi-menu
            </v-icon>

            <span class="text-h6">
              Menu
            </span>
          </div>

          <v-btn
            icon
            color="white"
            @click="drawerModel = false"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-divider class="mx-4" />

        <!-- =====================================================
             MENU
             Só esta zona faz scroll.
             ===================================================== -->
        <v-card-text
          class="
            mobile-menu-scroll
            flex-grow-1
            py-0
            px-0
            custom-scrollbar
          "
        >
          <NodeList
            :userData="user_data"
            :items="items"
            :isMini="false"
          />

          <v-list
            v-if="
              $store.getters.hasPermission([
                'super',
                'tickets.create'
              ])
            "
            nav
            dense
            color="transparent"
          >
            <v-list-item
              @click="emitTicketAndClose"
            >
              <v-list-item-icon>
                <v-icon>
                  mdi-ticket
                </v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                Ticket
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>

        <!-- =====================================================
             FOOTER MOBILE
             Fica preso ao fundo.
             ===================================================== -->
        <div class="mobile-menu-footer">
          <v-divider />

          <v-list
            nav
            dense
            color="transparent"
            class="mb-0"
          >
            <v-list-item
              @click="logout"
              class="logout-item"
            >
              <v-list-item-icon>
                <v-icon>
                  mdi-power
                </v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                Terminar Sessão
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NodeList from "@/components/UI/Lists/NodeList";

export default {
  name: "Nav",

  components: {
    NodeList,
  },

  props: {
    /*
     * v-model (Vue 2)
     *
     * Usado para abrir/fechar
     * o menu em mobile.
     */
    value: {
      type: Boolean,
      default: false,
    },

    isMini: {
      type: Boolean,
      default: false,
    },

    user_data: {
      type: Object,
      default: null,
    },
  },

  computed: {
    drawerModel: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit(
          "input",
          value
        );
      },
    },

    isMobile() {
      return (
        this.$vuetify.breakpoint.width <= 960
      );
    },

    canReadTrainings() {
      return this.$store.getters.hasPermission([
        "super",
        "trainings.read",
      ]);
    },

    canCreateTrainingForms() {
      return this.$store.getters.hasPermission([
        "super",
        "trainings.forms.create",
      ]);
    },

    trainingMenuItem() {
      /*
       * Se o utilizador pode criar formulários,
       * mostramos Formações como menu pai.
       */
      if (this.canCreateTrainingForms) {
        return {
          path: "/trainings",
          name: "Formações",
          icon: "mdi-school",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "trainings.read",
              "trainings.forms.create",
            ]),

          items: [
            {
              path: "/trainings",
              name: "Formações",
              icon:
                "mdi-format-list-bulleted",
              canShow:
                this.canReadTrainings,
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/trainings/forms",
              name: "Formulários",
              icon:
                "mdi-file-document-plus",
              canShow:
                this.canCreateTrainingForms,
              items: [],
              newTab: false,
              exact: true,
            },
          ],

          newTab: false,
          exact: true,
        };
      }

      /*
       * Caso normal:
       *
       * O utilizador não tem permissão
       * para gerir/criar formulários.
       *
       * Clica em Formações e entra
       * diretamente na listagem.
       */
      return {
        path: "/trainings",
        name: "Formações",
        icon: "mdi-school",
        canShow:
          this.canReadTrainings,
        items: [],
        newTab: false,
        exact: true,
      };
    },

    items() {
      return [
        {
          path: "/dashboard",
          name: "Dashboard",
          icon: "mdi-view-dashboard",
          items: [],
          newTab: false,
          exact: true,
        },

        {
          path: "/preventivas",
          name: "Máquinas",
          icon: "mdi-bulldozer",

          canShow:
            this.$store.getters.hasPermission([
              "super",
            ]),

          items: [],
          newTab: false,
          exact: true,
        },

        {
          path: "/despesas",
          name: "Despesas",
          icon: "mdi-currency-eur",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "expenses.read",
              "expenses.write",
              "expenses.update",
            ]),

          items: [],
          newTab: false,
          exact: true,
        },

        {
          path:
            "/section-diaries",
          name:
            "Diários de Secção",
          icon: "mdi-notebook",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "section_diaries.read",
              "section_diaries.manage",
            ]),

          items: [],
          newTab: false,
          exact: true,
        },

        /*
         * Formações
         *
         * Sem trainings.forms.create:
         *
         * Formações
         * -> /trainings
         *
         * Com trainings.forms.create:
         *
         * Formações
         *   - Formações
         *   - Formulários
         */
        this.trainingMenuItem,

        {
          path:
            "/ordens-trabalho",
          name:
            "Ordens de Trabalho",
          icon:
            "mdi-clipboard-text-clock",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "work_orders.read",
            ]),

          items: [],
          newTab: false,
          exact: true,
        },

        {
          path: "/diarios",
          name: "Diárias",
          icon: "mdi-notebook",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "diaries.read",
            ]),

          items: [
            {
              path:
                "/diarios/v2",
              name:
                "WebApp Diárias",
              icon:
                "mdi-magnify",

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "diaries.read",
                ]),

              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/diarios/dia",
              name:
                "Consulta diárias",
              icon:
                "mdi-magnify",

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "diaries.read",
                ]),

              items: [],
              newTab: false,
              exact: true,
            },

            {
              path: "/diarios",
              name:
                "ERP Diárias",
              icon:
                "mdi-magnify",
              canShow: false,
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/diarios/manobrador/registar",
              name:
                "Registar Diário Manobrador",
              canShow:
                this.checkPermission(1),
              icon:
                "mdi-plus-circle",
              items: [],
              newTab: true,
              exact: true,
            },

            {
              path:
                "/diarios/encarregado/registar",
              name:
                "Registar Diário Encarregado",

              canShow:
                this.$store.getters.hasRole(
                  "manobrador"
                )
                  ? false
                  : this.checkPermission(2),

              icon:
                "mdi-plus-circle",
              items: [],
              newTab: true,
              exact: true,
            },
          ],

          exact: true,
        },

        {
          path: "/kpi",
          name: "KPIs",
          icon: "mdi-bulldozer",
          exact: true,

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "kpi_diaries.read",
            ]),

          items: [
            {
              path:
                "/kpi/registar",
              name:
                "Registar Diária KPI",

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "kpi_diaries.create",
                ]),

              icon:
                "mdi-plus-circle",
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/kpi/lista-de-diarios",
              name:
                "Diárias KPI",
              icon:
                "mdi-magnify",

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "kpi_diaries.read",
                ]),

              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/kpi/lista-de-diarios-dia",
              name:
                "Consultar KPI/dia",
              icon:
                "mdi-magnify",

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "kpi_diaries.read",
                ]),

              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/kpi/work_work_units",
              name:
                "Obras vs UO",
              icon:
                "mdi-format-list-checks",
              canShow: false,
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/kpi/articulados",
              name:
                "Consulta de Articulados",
              icon:
                "mdi-hard-hat",
              items: [],
              exact: true,
              newTab: false,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "articulados.read",
                ]),
            },

            {
              path:
                "/kpi/list",
              name:
                "Lista de articulados",
              icon:
                "mdi-magnify",
              canShow: false,
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/kpi/activities",
              name:
                "Listagem de atividades",
              icon:
                "mdi-format-list-checks",
              canShow: false,
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/kpi/categories",
              name:
                "Listagem de categorias",
              icon:
                "mdi-apps-box",
              canShow: false,
              items: [],
              newTab: false,
              exact: true,
            },
          ],
        },

        {
          path:
            "/works_consult",
          name:
            "Consulta de Obras",
          icon:
            "mdi-hard-hat",
          items: [],
          exact: true,
          newTab: false,

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "work_consult.read",
              "work_ccost.read",
            ]),
        },

        {
          path:
            "/configuracoes",
          name:
            "Config. de Obra",
          icon: "mdi-cog",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "templates.read",
              "templates.create",
            ]),

          items: [
            {
              path:
                "/configuracoes/equipas",
              name:
                "Equipas",
              icon:
                "mdi-magnify",
              canShow: false,
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/configuracoes/templates",
              name:
                "Templates",
              icon:
                "mdi-magnify",

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "templates.read",
                ]),

              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/configuracoes/templates/registar",
              name:
                "Registar Template",
              icon:
                "mdi-plus-circle",

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "templates.create",
                ]),

              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/configuracoes/unities",
              name:
                "Gerir Unidades",
              icon:
                "mdi-truck",
              items: [],
              exact: true,
              newTab: false,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "unities.read",
                ]),
            },

            {
              path:
                "/configuracoes/materiais",
              name:
                "Lista materiais",
              icon:
                "mdi-magnify",
              items: [],
              exact: true,
              newTab: false,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "materials.read",
                ]),
            },

            {
              path:
                "/configuracoes/criar/materiais",
              name:
                "Registar Material",
              icon:
                "mdi-plus-circle",
              items: [],
              exact: true,
              newTab: false,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "materials.create",
                ]),
            },

            {
              path:
                "/configuracoes/subempreitadas",
              name:
                "Gestão subempreitadas",
              icon:
                "mdi-magnify",
              items: [],
              newTab: false,
              exact: true,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "subcontract.read",
                ]),
            },
          ],

          exact: true,
        },

        {
          path: "/epis",
          name: "EPIs",
          icon:
            "mdi-shield-sun",
          items: [],
          exact: true,
          newTab: false,

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "epis.read",
              "epis.delete",
              "epis.update",
              "epis.write",
              "epis.give",
            ]),
        },

        {
          path:
            "/garantias",
          name:
            "Garantias",
          icon:
            "mdi-file-document",

          canShow:
            this.$store.getters.hasRole([
              "super",
              "gestor_garantias_obra",
            ]),

          items: [
            {
              path:
                "/garantias/obras",
              name:
                "Gestão de garantias",
              icon:
                "mdi-hard-hat",
              items: [],
              newTab: false,
              exact: true,
            },

            {
              path:
                "/garantias/clients",
              name:
                "Gestão de Clientes",
              icon:
                "mdi-account",
              items: [],
              newTab: false,
              exact: true,
            },
          ],
        },

        {
          path: "/frota",
          name: "Frota",
          icon:
            "mdi-bulldozer",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "external_communications.read",
              "works_schedule.read",
              "works_schedule.create",
              "odc_machines.read",
              "odc_machines.create",
            ]),

          items: [
            {
              path:
                "/frota/external_communications",
              name:
                "Comunicações Externas",
              icon:
                "mdi-paperclip",
              exact: true,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "external_communications.read",
                ]),

              items: [],
            },

            {
              path:
                "/frota/work_schedule",
              name:
                "Horário de Obras",
              icon:
                "mdi-clock",
              exact: true,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "works_schedule.read",
                  "works_schedule.create",
                ]),

              items: [
                {
                  path:
                    "/frota/works_schedule",
                  name:
                    "Consultar obras",
                  icon:
                    "mdi-magnify",

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "odc_machines.read",
                    ]),

                  items: [],
                  exact: true,
                },

                {
                  path:
                    "/frota/works_schedule/registar",
                  name:
                    "Registar horário de obras",
                  icon:
                    "mdi-plus-circle",

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "odc_machines.create",
                    ]),

                  items: [],
                  exact: true,
                },
              ],
            },

            {
              path:
                "/frota/odc_machines",
              name:
                "Máquinas",
              icon:
                "mdi-bulldozer",
              exact: true,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "odc_machines.read",
                  "odc_machines.create",
                ]),

              items: [
                {
                  path:
                    "/frota/odc_machines",
                  name:
                    "Consultar máquinas",
                  icon:
                    "mdi-magnify",

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "odc_machines.read",
                    ]),

                  items: [],
                  exact: true,
                },

                {
                  path:
                    "/frota/odc_machines/registar",
                  name:
                    "Registar máquina",
                  icon:
                    "mdi-plus-circle",

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "odc_machines.create",
                    ]),

                  items: [],
                  exact: true,
                },
              ],
            },

            {
              path:
                "/frota/worker_card",
              name:
                "Associaçao de cartão de Manobrador",
              icon:
                "mdi-account",
              exact: true,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "worker_card.read",
                  "worker_card.create",
                ]),

              items: [
                {
                  path:
                    "/frota/worker_card",
                  name:
                    "Consultar cartões de manobrador",
                  icon:
                    "mdi-magnify",

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "worker_card.read",
                    ]),

                  items: [],
                  exact: true,
                },

                {
                  path:
                    "/frota/worker_card/registar",
                  name:
                    "Registar cartões de manobrador",
                  icon:
                    "mdi-plus-circle",
                  items: [],
                  exact: true,
                  newTab: false,

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "worker_card.create",
                    ]),
                },
              ],
            },
          ],
        },

        {
          path:
            "/suppliers",
          name:
            "Fornecedores",
          icon:
            "mdi-truck-delivery",
          items: [],
          newTab: false,
          exact: true,

          canShow: false,
            /*this.$store.getters.hasPermission([
              "super",
              "fornecedores.read",
            ]),*/
        },

        {
          path:
            "/evaluations",
          name:
            "Avaliações",
          icon:
            "mdi-chart-line-variant",
          items: [],
          newTab: false,
          exact: true,

          canShow: false,
            /*this.$store.getters.hasPermission([
              "super",
              "supplier_evaluations.read",
            ]),*/
        },

        {
          path: "/super",
          name:
            "Definições",
          icon:
            "mdi-shield-crown",

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "users.read",
              "users.create",
              "roles.read",
              "roles.create",
            ]),

          items: [
            {
              path:
                "/super/utilizadores",
              name:
                "Utilizadores",
              icon:
                "mdi-account",
              exact: false,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "users.read",
                  "users.create",
                ]),

              items: [
                {
                  path:
                    "/super/utilizadores",
                  name:
                    "Consultar Utilizadores",
                  icon:
                    "mdi-magnify",

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "users.read",
                    ]),

                  items: [],
                  newTab: false,
                  exact: true,
                },

                {
                  path:
                    "/super/utilizadores/registar",
                  name:
                    "Registar Utilizador",
                  icon:
                    "mdi-plus-circle",
                  items: [],
                  exact: false,
                  newTab: false,

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "users.create",
                    ]),
                },
              ],

              exact: true,
            },

            {
              path:
                "/super/roles",
              name: "Roles",
              icon:
                "mdi-shield-key",
              exact: false,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "roles.read",
                  "roles.create",
                ]),

              items: [
                {
                  path:
                    "/super/roles",
                  name:
                    "Consultar Roles",
                  icon:
                    "mdi-magnify",
                  items: [],
                  newTab: false,

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "roles.read",
                    ]),

                  exact: true,
                },

                {
                  path:
                    "/super/roles/registar",
                  name:
                    "Registar Role",
                  icon:
                    "mdi-plus-circle",
                  items: [],
                  newTab: false,

                  canShow:
                    this.$store.getters.hasPermission([
                      "super",
                      "roles.create",
                    ]),

                  exact: false,
                },
              ],

              exact: true,
            },

            {
              path:
                "/super/logs",
              name: "Logs",
              icon:
                "mdi-airplane",
              items: [],
              exact: true,
              newTab: false,

              canShow:
                this.$store.getters.hasPermission([
                  "super",
                  "logs.read",
                ]),
            },
          ],

          exact: true,
        },

        {
          path: "/exports",
          name:
            "Exportações",
          icon:
            "mdi-paperclip",
          items: [],
          exact: true,
          newTab: false,

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "exports.create",
              "export.diaries",
              "diaries.export_manouver_diary",
              "export.perf_report",
              "export.kpi",
              "export.faults",
              "export.materials",
              "export.subempreitadas",
              "export.rh",
              "supplier_evaluations.export",
              "export.section_diaries",
            ]),
        },

        {
          path:
            "/imports",
          name:
            "Importações",
          icon:
            "mdi-paperclip",
          items: [],
          exact: true,
          newTab: false,

          canShow:
            this.$store.getters.hasPermission([
              "super",
              "import.guarantees",
              "import.work_units",
              "import.mqt",
            ]),
        },

        {
          path:
            "/howtodo",
          name:
            "Como fazer",
          icon:
            "mdi-help-circle",
          items: [],
          exact: true,
          newTab: false,

          canShow:
            this.$store.getters.hasPermission([
              "super",
            ]),
        },

        {
          path:
            "/system-settings",
          name:
            "Gestão de Sistema",
          icon:
            "mdi-cog",
          items: [],
          exact: true,
          newTab: false,

          canShow:
            this.$store.getters.hasPermission([
              "super",
            ]),
        },
      ];
    },
  },

  watch: {
    /*
     * Fecha automaticamente a modal
     * quando navegamos para outra rota
     * em mobile.
     */
    $route() {
      if (this.isMobile) {
        this.drawerModel = false;
      }
    },
  },

  methods: {
    checkPermission(level) {
      if (
        this.$store.getters.hasRole([
          "super",

          level == 1
            ? "manobrador"
            : "encarregado",

          "administrativo",
        ])
      ) {
        return true;
      }

      if (
        this.$store.getters.hasPermission([
          "diaries.create",
        ])
      ) {
        return true;
      }

      return false;
    },

    emitTicketAndClose() {
      this.$emit("ticket");

      if (this.isMobile) {
        this.drawerModel = false;
      }
    },

    /*
     * Fallback:
     * caso o NodeList não emita nada,
     * fechamos ao navegar.
     */
    closeOnNavigate() {
      if (this.isMobile) {
        this.drawerModel = false;
      }
    },

    /*
     * =========================================================
     * TERMINAR SESSÃO
     * =========================================================
     *
     * Mantém exatamente o comportamento
     * que já temos no Nexus.
     *
     * NÃO:
     * - faz logout no Keycloak;
     * - chama o backend;
     * - limpa cookies;
     * - limpa localStorage;
     * - manda para /login.
     *
     * Apenas regressa ao dashboard
     * central do Olympus.
     */
    logout() {
      const portalUrl =
        process.env.VUE_APP_LAUNCHER_URL;

      if (!portalUrl) {
        console.error(
          "VUE_APP_LAUNCHER_URL não está configurado."
        );

        return;
      }

      const normalizedUrl =
        portalUrl.endsWith("/")
          ? portalUrl
          : portalUrl + "/";

      window.location.href =
        normalizedUrl + "dashboard";
    },
  },
};
</script>

<style scoped>
/*
 * =========================================================
 * DRAWER DESKTOP
 * =========================================================
 *
 * O drawer inteiro não faz scroll.
 *
 * Ele é dividido em:
 *
 * 1. zona central flexível;
 * 2. footer fixo no fundo.
 */
.navigation-layout {
  height: 100%;
  min-height: 0;

  display: flex;
  flex-direction: column;
}

/*
 * Esta é a única zona do drawer
 * que pode fazer scroll.
 */
.navigation-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

/*
 * Footer nunca encolhe.
 *
 * Como está fora da zona
 * navigation-scroll, fica sempre
 * visível no fundo.
 */
.navigation-footer {
  flex: 0 0 auto;
  width: 100%;
}

/*
 * =========================================================
 * LOGOUT
 * =========================================================
 */
.logout-item {
  cursor: pointer;
}

/*
 * =========================================================
 * MOBILE
 * =========================================================
 */
.mobile-menu-card {
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;

  overflow: hidden;
}

/*
 * Cabeçalho mobile.
 *
 * Não faz scroll.
 */
.mobile-menu-header {
  flex: 0 0 auto;
}

/*
 * Só esta parte faz scroll.
 */
.mobile-menu-scroll {
  flex: 1 1 auto;
  min-height: 0;

  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/*
 * Footer mobile sempre no fundo.
 */
.mobile-menu-footer {
  flex: 0 0 auto;
  width: 100%;
}

/*
 * =========================================================
 * SCROLLBAR
 * =========================================================
 */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: white transparent;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #1a237e;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #0d153f;
}

.custom-scrollbar::-webkit-scrollbar-button {
  display: none;
}
</style>